import JoinContainer from "./JoinContainer";

export default JoinContainer;
